import {
  Camera,
  OrthographicCamera,
  PerspectiveCamera,
  Vector2,
  Vector3,
  WebGLRenderer,
} from 'three';

import { degreesToRadians } from '../../utilities/math-helpers';

const tmpSize = new Vector2();
const tmpPosition = new Vector3();

/**
 * Gets the size in world units of a pixel at the position, to keep objects the same size on screen.
 */
export const getWorldPerPixel = (renderer: WebGLRenderer, camera: Camera, position: Vector3) => {
  const viewportHeight = renderer.getSize(tmpSize).y;

  // Nothing is shown without a viewport, so the objects can collapse instead of becoming infinite.
  if (viewportHeight <= 0) {
    return 0;
  }

  if ((camera as PerspectiveCamera).isPerspectiveCamera) {
    const { fov } = camera as PerspectiveCamera;
    // The size on screen depends on the depth along the view direction, not the distance,
    // otherwise objects grow towards the edges of the screen.
    const depth = -tmpPosition.copy(position).applyMatrix4(camera.matrixWorldInverse).z;

    return (2 * depth * Math.tan(degreesToRadians(fov) / 2)) / viewportHeight;
  }

  const { top, bottom, zoom } = camera as OrthographicCamera;
  return (top - bottom) / (zoom || 1) / viewportHeight;
};
